import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class AplicativoProvider {
  baseUrl = environment.API_URL;
  aplicativoDadosHome = null;

  constructor(public http: HttpClient) { }

  informacoesAplicativo() {
    return this.http.post<any>(this.baseUrl + '/aplicativo/informacoes-aplicativo', {})
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  atualizarCadastro() {
    return this.http.post<any>(this.baseUrl + '/aplicativo/atualizar-cadastro', {})
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  setDadosHome(dados: any) {
    this.aplicativoDadosHome = dados;
  }

  getDadosHome() {
    return this.aplicativoDadosHome;
  }

  public configApp(idInstituicao: any) {
    return this.http.post<any>(this.baseUrl + '/aplicativo/config-app', { 'idInstituicao': idInstituicao })
      .pipe(map(data => {
        return data;
      }));
  }
}
